module.exports = __webpack_public_path__ + "static/media/16.ea7c3315.jpg";